/**
 * =============================================================================
 * COOKIE SETTINGS BUTTON - Botão para reabrir as Preferências de Cookies
 * =============================================================================
 *
 * Botão reutilizável para abrir o painel de preferências de cookies.
 * Pode ser usado no rodapé, numa página de política de cookies, etc.
 */

import { Settings } from "lucide-react";
import { useCookies } from "@/hooks/useCookies";

interface CookieSettingsButtonProps {
  className?: string;
  variant?: "link" | "button";
  showIcon?: boolean;
}

export function CookieSettingsButton({
  className = "",
  variant = "link",
  showIcon = true,
}: CookieSettingsButtonProps) {
  const { openPreferences, t } = useCookies();

  if (variant === "button") {
    return (
      <button
        onClick={openPreferences}
        className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-oceanBlue focus:ring-offset-2 ${className}`}
      >
        {showIcon && <Settings size={16} />}
        {t.settingsLabel}
      </button>
    );
  }

  return (
    <button
      onClick={openPreferences}
      className={`inline-flex items-center gap-1.5 text-sm underline-offset-4 hover:underline transition-colors focus:outline-none focus:ring-2 focus:ring-oceanBlue focus:ring-offset-2 rounded ${className}`}
    >
      {showIcon && <Settings size={14} />}
      {t.settingsLabel}
    </button>
  );
}

export default CookieSettingsButton;
